import { render, staticRenderFns } from "./CafeFancafe.vue?vue&type=template&id=8a6ae4b8&"
import script from "./CafeFancafe.vue?vue&type=script&lang=js&"
export * from "./CafeFancafe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8a6ae4b8', component.options)
    } else {
      api.reload('8a6ae4b8', component.options)
    }
    module.hot.accept("./CafeFancafe.vue?vue&type=template&id=8a6ae4b8&", function () {
      api.rerender('8a6ae4b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/CafeFancafe.vue"
export default component.exports